import { useEffect, useState } from 'react';

import { useMenus } from '../../../../hooks/useMenus';

import './edit-meal-modal.scss';

import { Button } from '../../../common/button/Button';
import { FoodCard } from '../../../common/food-card/FoodCard';
import { GramSelector } from '../../../common/gram-selector/GramSelector';
import { AdaptiveModal } from '../../../modal/AdaptiveModal';

export const EditMealModal = ({ open, onClose, meal, planId, updateSelections, onSaved }) => {
  const { customFields } = useMenus();
  const [localSelections, setLocalSelections] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!meal) return;
    const initial = {};
    (meal.selections ?? []).forEach((s) => {
      initial[s.field.id] = { itemId: s.item.id, grams: s.grams };
    });
    setLocalSelections(initial);
  }, [meal]);

  const setItem = (fieldId, item) =>
    setLocalSelections((s) => ({ ...s, [fieldId]: { itemId: item.id, grams: s[fieldId]?.grams ?? 100 } }));

  const setGrams = (fieldId, grams) =>
    setLocalSelections((s) => ({ ...s, [fieldId]: { ...s[fieldId], grams } }));

  const handleSave = () => {
    const selections = Object.entries(localSelections)
      .filter(([, v]) => v.itemId)
      .map(([fieldId, v]) => ({ fieldId, itemId: v.itemId, grams: v.grams }));

    setSaving(true);
    updateSelections({ planId, mealId: meal.id, selections })
      .then((updatedMeal) => {
        onSaved(updatedMeal);
        onClose();
      })
      .finally(() => setSaving(false));
  };

  return (
    <AdaptiveModal
      open={open}
      onOpen={onClose}
      contentStyle={{ minWidth: '360px', width: '480px', maxWidth: '96vw', height: '85vh' }}
    >
      <div className="edit-meal-modal">
        <h2 className="edit-meal-modal__title">Edit {meal?.slotName}</h2>
        <div className="edit-meal-modal__scroll">
          {(customFields ?? []).filter((f) => f.active !== false).map((field) => {
            const current = localSelections[field.id];
            const currentItem = (field.fieldItems ?? []).find((i) => i.id === current?.itemId);
            return (
              <div key={field.id} className="edit-meal-modal__field">
                <div className="edit-meal-modal__field-name">{field.name}</div>
                <div className="food-card-grid">
                  {(field.fieldItems ?? []).map((item) => (
                    <FoodCard
                      key={item.id}
                      item={item}
                      selected={current?.itemId === item.id}
                      categoryImageUrl={field.imageUrl}
                      onSelect={(food) => setItem(field.id, food)}
                    />
                  ))}
                </div>
                {currentItem && (
                  <GramSelector grams={current.grams} onChange={(g) => setGrams(field.id, g)} />
                )}
              </div>
            );
          })}
        </div>
        <div className="edit-meal-modal__footer">
          <Button large onClick={handleSave} loading={saving}>Save</Button>
          <Button secondary large onClick={onClose} disabled={saving}>Cancel</Button>
        </div>
      </div>
    </AdaptiveModal>
  );
};
